import { Typography, Paper } from '@material-ui/core';
import styled from 'styled-components';

// export const Wrapper = styled.div`
//   display: flex;
//   flex-direction: column;
// `;

// export const WrapperHeader = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: flex-start;
//   padding: 0.5rem 0;
//   p {
//     margin-left: 1.5rem;
//     color: #3f51b5;
//     font-weight: 700;
//     text-transform: uppercase;
//   }
// `;

// export const WrapperGroupText = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
// `;

// export const WrapperInputs = styled.div`
//   display: flex;
//   flex-direction: column;
//   padding: 0.5rem 0;
//   border-bottom: 1px solid rgba(0, 0, 0, 0.1);
// `;

 export const WrapperTitle = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-bottom: 1.1rem;
   > p {
     text-transform: uppercase;
     font-weight: 700;
     font-size: 1.2rem;
   }
 `;

// export const WrapperGroupInput = styled.div`
//   margin-top: 0.5rem;
//   margin-bottom: 0.5rem;
//   display: grid;
//   grid-template-columns: repeat(2, 1fr) 2fr;
//   grid-gap: 1.5rem;
// `;

// export const WrapperGrid = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   > div:not(:first-child) {
//     margin-top: 1.5rem;
//   }
// `;

 export const WrapperTabela = styled(Paper)`
   padding: 1rem;
   width: 100%;
   display: flex;
   flex-direction: column;
   .MuiTableContainer-root {
     max-height: ${(props) => props.height};
     ::-webkit-scrollbar {
       width: 8px;
       height: 8px;
     }
     ::-webkit-scrollbar-thumb {
       background-color: rgba(0, 0, 0, 0.2);
       border-radius: 4px;
     }
     ::-webkit-scrollbar-track {
       background-color: #eaeaea;
     }
   } 
 `;

 export const Footer = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   margin-top: 2rem;
   p {
     font-size: 1.2rem;
     font-weight: 700;
     color: #666;
   }
   span {
     text-transform: uppercase;
   }
 `;

 export const WrapperSearch = styled.div`
   display: flex;
   align-items: center;
   justify-content: flex-end;
   flex: 1;
 `;